import { useState, useEffect } from 'react'

export default (url) =>{
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(()=>{
        //let apiUrl = `https://api.nasa.gov/planetary/apod?api_key=qfu92Q3t1xBcZPHWCphiBhTZrqnB3KhQfsKNnbME`
        fetch(url)
        .then(resp => resp.json())
        .then(data => setData(data))
        .catch(err => setError(err))
        .finally(() => setLoading(false))
    }, [url])
    return [data, loading, error]
}